import React from "react";

import { Field } from "formik";
import isEqual from "lodash/isEqual";
import { connect } from "react-redux";

import PurchaseDetails from "./PurchaseDetails";
import CalculatedField from "./CalculatedField";
import LoanRequestFields from "./LoanRequestFields";

import TextField from "../../components/CstmTextField";

import { PAGES } from "../../config/constants";

import { saveToCRM } from "../../actions/saveToCRM.actions";

class EnchancedForm2 extends React.Component {
  componentDidUpdate(prevProps, prevState) {
    const { setValuesChanged, values } = this.props;

    if (isEqual(values, prevProps.values) === false) {
      setValuesChanged(values);
    }
  }

  render() {
    const { values, handleSubmit, setPrevPage } = this.props;

    return (
      <div className="container-fluid">
        <div className="row">
          <div className="col-md-6">
            <PurchaseDetails />
          </div>

          <div className="col-md-6">
            <LoanRequestFields values={values} />

            <Field
              name="special_notes"
              label="Special Notes"
              component={TextField}
              multiline
              required
              formControlStyle={{ style: { marginTop: 15 } }}
            />

            <CalculatedField values={values} />
          </div>
        </div>
        <div className="row">
          <div className="col-md-12">
            <div style={{ marginTop: 10 }}>
              <div style={{ float: "left" }}>
                <button
                  type="button"
                  className="cstm_btn cstm_btn-text"
                  onClick={setPrevPage}
                >
                  Back
                </button>
              </div>
              <div style={{ float: "right" }}>
                <button
                  type="button"
                  className="cstm_btn cstm_btn-blue"
                  onClick={handleSubmit}
                >
                  Submit Loan
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapDispatch = (dispatch) => {
  return {
    setPrevPage: () => {
      dispatch({
        type: "SET_PAGE",
        payload: PAGES.CONSOLE_BROOK_1,
      });
    },

    setValuesChanged: (values) => {
      dispatch({
        type: "SET_CONSOLE_BROK1",
        payload: values,
      });
    },

    setValues: (values) => {
      dispatch({
        type: "SET_CONSOLE_BROK1",
        payload: values,
      });

      dispatch(saveToCRM());
    },
  };
};

export default connect(null, mapDispatch)(EnchancedForm2);



// WEBPACK FOOTER //
// ./src/Screens/ConsoleBrok/EnhancedForm2.js